import dynamic from 'next/dynamic';
const modal = dynamic(() => import('./modal'));
export default modal;
